import { createContext } from 'react';

/**
 * Webapp URL parameters mapped to contexts.
 *
 * The AppUrlParamProvider manages the values of these contexts.
 *
 * Example:
 *
 * ```tsx
 * const shareId = use(AppParams.share);
 * const [, replaceState] = use(UpdateAppParams);
 * const openPopup = useCallback((shareId: string) => {
 *   replaceState({ share: shareId });
 * }, [replaceState]);
 * const closePopup = useCallback(() => {
 *   replaceState({ share: null });
 * }, [replaceState]);
 * ```
 */
export const APP_URL_PARAMS = {
  lang: createContext<string | null>(null),
  share: createContext<string | null>(null),
  members_dialog_open: createContext<string | null>(null),
  whats_new_item: createContext<string | undefined | 'invalid'>(undefined),
  ar: createContext<string | undefined | 'invalid'>(null),
  feedback: createContext<string | null>(null),
};

export type UpdateAppParamsFn = (
  update: Partial<Record<keyof typeof APP_URL_PARAMS, string | null>>
) => void;
export const UpdateAppParams = createContext<
  [UpdateAppParamsFn, UpdateAppParamsFn]
>([
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {},
]);

export default APP_URL_PARAMS;
